'use client';
import React, { useEffect, useRef } from 'react';

import Image from 'next/image';

import Booker from '@components/views/landing/components/booker/Booker';
import { useDevice } from '@contexts/device';
import { logErrorPage } from '@utils/gtm/error-log-gtm';

import {
  BookerContainer,
  ErrorContainer,
  ErrorContainer503,
  ErrorImageContainer,
  ErrorTextContainer,
  HeroImageContainer,
} from './styled';

export type ErrorPageContainerProps = {
  errorPageCode: string;
  errorTextFirstLine: string;
  errorTextSecondLine: string;
};

const ErrorPageContainer = ({
  errorPageCode,
  errorTextFirstLine,
  errorTextSecondLine,
}: ErrorPageContainerProps) => {
  const { isDesktop } = useDevice();

  const isLogged = useRef(false);

  useEffect(() => {
    if (!isLogged.current) {
      try {
        logErrorPage(
          errorPageCode?.split('/').pop()?.replace('.png', '') ?? ''
        );
        isLogged.current = true;
      } catch (error) {
        console.error(error);
      }
    }
  }, [errorPageCode]);

  return (
    <>
      <HeroImageContainer>
        <Image
          src='/static/images/error/error-page-background.svg'
          fill
          alt='Not found'
          priority
        />
      </HeroImageContainer>
      {errorPageCode.split('/')[4] === '503.png' ? null : (
        <BookerContainer>
          <Booker isHoliday={false} hasError={true} />
        </BookerContainer>
      )}
      {errorPageCode.split('/')[4] === '503.png' ? (
        <ErrorContainer503>
          <ErrorImageContainer>
            {isDesktop ? (
              <Image
                src={errorPageCode}
                width={241}
                height={108.5}
                alt='Not found'
              />
            ) : (
              <Image
                src={errorPageCode}
                width={120}
                height={54}
                alt='Not found'
              />
            )}
          </ErrorImageContainer>
          <ErrorTextContainer>
            <span>
              {errorTextFirstLine} <br /> {errorTextSecondLine}
            </span>
          </ErrorTextContainer>
        </ErrorContainer503>
      ) : (
        <ErrorContainer>
          <ErrorImageContainer>
            {isDesktop ? (
              <Image
                src={errorPageCode}
                width={241}
                height={108.5}
                alt='Not found'
              />
            ) : (
              <Image
                src={errorPageCode}
                width={120}
                height={54}
                alt='Not found'
              />
            )}
          </ErrorImageContainer>
          <ErrorTextContainer>
            <span>
              {errorTextFirstLine} <br /> {errorTextSecondLine}
            </span>
          </ErrorTextContainer>
        </ErrorContainer>
      )}
    </>
  );
};

export default ErrorPageContainer;
